import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { H6, Image, LI } from "../../../AbstractElements";
import { Back, Pinned } from "../../../Constant";
import { V_MENU } from "../../../Data/Sidebar/VerticalMenu";
import { dynamicImage } from "../../../Service/DynamicImage";
import { SubMenu } from "./SubMenu";
import { useTranslation } from "react-i18next";

const SidebarMain = () => {
  const [isOpen, setIsOpen] = useState([]);
  const { t } = useTranslation();


  return (
    <SimpleBar style={{ maxHeight: 300 }}>
      <LI className="back-btn">
        <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
          <Image className="image-fluid" src={dynamicImage("logo/logo-icon.png")} alt="" />
        </Link>
        <div className="mobile-back text-end">
          <span>{Back}</span>
          <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
        </div>
      </LI>
      <LI className="pin-title sidebar-main-title">
        <div>
          <H6>{Pinned}</H6>
        </div>
      </LI>
      {V_MENU.map((item, index) => (
        <Fragment key={index}>
          {item.title && (
            <LI className="sidebar-main-title">
              <div>
                <H6>{t(item.title)}</H6>
              </div>
            </LI>
          )}
          <SubMenu menu={item.menu} isOpen={isOpen} setIsOpen={setIsOpen} level={0} />
        </Fragment>
      ))}
</SimpleBar>
  );
};

export default SidebarMain;
